//messages.js
export default {
    project_id: "Project Id",
    company_id: "Company Id",
    project_name: "Project Name",
    serial_number: "Serial Number",
    model: "Model",
    manufacture_date: "Manufacture Date",
    contact_name: "Contact Name",
    contact_email: "Contact Email",
    contact_phone: "Contact Phone",
    start_date: "Start Date",
    end_date: "End Date",
    po_issue_date: "Po Issue Date",
    po_received_date: "Po Received Date",
    customer_po: "Customer PO",
    notes: "Notes",
    edit_project: "Edit Project",
    add_project: "Add Project",
    delete_project: "Delete Project",
    projects: "Projects",
    delete_project_confirm: "This action is not reversible!",
    modify_project: "Modify Project",
    project: "Project #",
};
